module.exports = __webpack_public_path__ + "static/uv-fr-logo-994f087fe6c67026a1709bb1a47c34e9.png";